/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PersonDocumentType = {
  type: 'Enum',
} as const;
